import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { setServerValidation } from "redux/actions/main";

const KNModal = (props) => {
  const description = props?.description ? props.description : "";
  const bodyClass = props?.bodyClass ? props.bodyClass : "";
  const bodyClassPad = props?.bodyClassPad ? props.bodyClassPad : "";
  const headerClassPad = props?.headerClassPad ? props.headerClassPad : "";

  return (
    <>
      <Transition appear show={props?.isOpen} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-50 overflow-y-auto"
          onClose={() => {
            props?.setServerValidation({});
            props?.closeModal();
          }}
        >
          <div className="min-h-screen px-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-50" />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className="inline-block h-screen align-middle"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div
                className={`inline-block max-w-3xl w-full  transition-all transform bg-white shadow-xl rounded-lg ${bodyClass}`}
              >
                <div
                  className={`bg-white rounded-lg py-8 sm:px-8 px-6 ${bodyClassPad}`}
                >
                  <div
                    className={`modal-header sm:flex items-center gap-3 pb-3 mb-3 ${headerClassPad}`}
                  >
                    {props?.icon ? (
                      props.icon
                    ) : (
                      <>
                        {props?.iconType && (
                          <div className="">
                            {" "}
                            <ModalIcons type={props.iconType} />{" "}
                          </div>
                        )}
                      </>
                    )}
                    <div className="mt-3 text-center sm:mt-0 sm:text-left">
                      <Dialog.Title
                        as="h2"
                        className="text-2xl leading-relaxed font-Inter font-bold mb-0 text-gray-900"
                      >
                        {props?.title}
                      </Dialog.Title>
                      <div className="modal-close z-10">
                        <button
                          className="bg-white"
                          onClick={props?.closeModal}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                            className="w-6 h-6 text-gray-500"
                          >
                            <path
                              fillRule="evenodd"
                              d="M5.47 5.47a.75.75 0 011.06 0L12 10.94l5.47-5.47a.75.75 0 111.06 1.06L13.06 12l5.47 5.47a.75.75 0 11-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 01-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 010-1.06z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>

                  <section className="text-left">
                    <div className="mt-0">
                      <p className="sm:text-lg text-base text-gray-500 font-Inter">
                        {description}
                      </p>
                    </div>
                    <div className="mt-0 font-Inter">{props?.body}</div>
                  </section>
                </div>

                {!props?.noFooter ? (
                  <>
                    <div className="flex items-center justify-end gap-3 py-5 px-5">
                      {props?.footerButtons ? (
                        props.footerButtons
                      ) : (
                        <button
                          type="button"
                          className="btn btn-dash-cancel"
                          onClick={props?.closeModal}
                        >
                          Dismiss
                        </button>
                      )}
                    </div>
                  </>
                ) : null}
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

const ModalIcons = (props) => {
  switch (props.type) {
    case "info":
      return (
        <div className="mx-auto flex-shrink-0 flex items-center justify-center h-8 w-8 rounded-full bg-cyan-100 sm:mx-0 sm:h-8 sm:w-8">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 text-cyan-500"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>
      );

    case "error":
      return (
        <div className="mx-auto flex-shrink-0 flex items-center justify-center h-8 w-8 rounded-full bg-red-100 sm:mx-0 sm:h-8 sm:w-8">
          <svg
            className="h-6 w-6 text-red-600"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
        </div>
      );

    case "confirmation":
      return (
        <div className="mx-auto flex-shrink-0 flex items-center justify-center h-8 w-8 rounded-full bg-red-100 sm:mx-0 sm:h-8 sm:w-8">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 text-red-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>
      );
    default:
      return <></>;
  }
};

KNModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  bodyClass: PropTypes.string,
  onClose: PropTypes.func,
  title: PropTypes.string,
  description: PropTypes.string,
  body: PropTypes.any,
  noFooter: PropTypes.bool,
  footerButtons: PropTypes.any,
  setModalOpen: PropTypes.func,
  closeModal: PropTypes.func.isRequired,
};

const mapStateToProps = () => ({});

const mapDispatchToProps = {
  setServerValidation,
};

export default connect(mapStateToProps, mapDispatchToProps)(KNModal);
